<template>
  <!--Navigation menu block-->
  <!-- Reference : https://bulma.io/documentation/columns/sizes/ -->
  <div id="nav">
    <div id="head">
      <div id="logos">
        <img id="icon" src="@/assets/logo.png">
        <h1 id="logo">
          IOI.
        </h1>
        <button id="logout" @click="logout">
          Logout
        </button>
      </div>
    </div>
    <!--<router-link to="/signup">SignUp</router-link> |-->
    <hr>
  </div>
</template>

<script>
import registration from '@/js/registration.js';

export default {
  name: 'Header',
  methods: {
    logout() {
      registration.logout();
    },
  },
};
</script>

<style>
@media screen and (max-width:768px){
  /*画面サイズが480pxからはここを読み込む*/
  #icon{
  width: 15px;
  }
  #logo{
  font-size: 1em;
  }
  #logout{
  padding: 5px;
  height: 25px;
  border-radius: 5px;
  }
}
@media screen and (min-width:768px) and ( max-width:1024px) {
  /*画面サイズが768pxから1024pxまではここを読み込む*/
  #icon{
  width: 25px;
  }
  #logo{
  font-size: 2em;
  }
  #logout{
  padding: 15px;
  height: 30px;
  border-radius: 10px;
  }
}
@media screen and (min-width:1024px) {
  /*画面サイズが1024pxからはここを読み込む*/
  #icon{
  width: 30px;
  }
  #logo{
  font-size: 2em;
  }
  #logout{
  padding: 15px;
  border-radius: 10px;
  }
}

hr{
  width: 100%;
}

#nav {
  position: relative;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#head{
  width: 100%;
  margin-bottom: 15px;
}

#logos{
 width: 100%;
}

#icon{
  display: inline;
  vertical-align: baseline;
}

#logo{
  display: inline;
  margin-left: 15px;
  color: #42b983;
  vertical-align: baseline;
}

#logout{
  float: right;
  vertical-align: baseline;
  border: solid #42b983 2px;
  transition: 0.1s;
  position: relative;
}

#logout:hover {
  background-color: #42b983;
  transition: 0.3s;
  border-radius: 30px;
  cursor: pointer;
}
</style>
